import { render, staticRenderFns } from "./AvatarPicker.vue?vue&type=template&id=5809faf2&scoped=true&"
import script from "./AvatarPicker.vue?vue&type=script&lang=js&"
export * from "./AvatarPicker.vue?vue&type=script&lang=js&"
import style0 from "./AvatarPicker.vue?vue&type=style&index=0&id=5809faf2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5809faf2",
  null
  
)

export default component.exports